import {
  buildStoreListRequest,
  storeApiResources,
} from '@eliadmin/core/src/api/store-list-request';
import type { Image } from '@eliadmin/core/src/api/manufacturers/types/manufacturers-types';
import type { TDynamicData } from '../../types/dynamic-data';

import { fetchData } from '@eliadmin/core/src/api/fetcher';

export type ReferenceCategory = {
  id: number;
  name: string;
  image?: Image | null;
};

export async function fetchHeroSlides({ locale }: { locale: string }) {
  return await fetchData<{ data: TDynamicData[] }>({
    locale,
    ...buildStoreListRequest(storeApiResources.storeDynamicSectionsDynamics, {
      where: { dynamicSectionId: { in: [1] } },
    }),
  }).then(r => r.data);
}

export async function fetchBrands({ locale }: { locale: string }) {
  return await fetchData<{ data: TDynamicData[] }>({
    locale,
    ...buildStoreListRequest(storeApiResources.storeDynamicSectionsDynamics, {
      where: { dynamicSectionId: { in: [2] } },
    }),
  }).then(r => r.data);
}

export async function fetchFAQ({ locale }: { locale: string }) {
  return await fetchData<{ data: TDynamicData[] }>({
    locale,
    ...buildStoreListRequest(storeApiResources.storeDynamicSectionsDynamics, {
      where: { dynamicSectionId: { in: [3] } },
    }),
  }).then(r => r.data);
}

export async function fetchPromoBanners({ locale }: { locale: string }) {
  return await fetchData<{ data: TDynamicData[] }>({
    locale,
    ...buildStoreListRequest(storeApiResources.storeDynamicSectionsDynamics, {
      where: { dynamicSectionId: { in: [6] } },
    }),
  }).then(r => r.data);
}

export async function fetchServiceBenefits({ locale }: { locale: string }) {
  return await fetchData<{ data: TDynamicData[] }>({
    locale,
    ...buildStoreListRequest(storeApiResources.storeDynamicSectionsDynamics, {
      where: { dynamicSectionId: { in: [7] } },
    }),
  }).then(r => r.data);
}

export async function fetchWords({ locale }: { locale: string }) {
  return await fetchData<{ data: TDynamicData[] }>({
    locale,
    ...buildStoreListRequest(storeApiResources.storeDynamicSectionsDynamics, {
      where: { dynamicSectionId: { in: [8] } },
    }),
  });
}
